import { Response } from '@/infra/adapters/models';

export class AuthenticationError<T> extends Error {
    private _code: number;
    private _result: T;
    constructor(resp: Response<T>) {
        console.trace(resp);
        super(resp.message);
        this._code = resp.resultCode;
        this._result = resp.result;
    }
    public get code() {
        return this._code;
    }
    public get result() {
        return this._result;
    }
}

export class InvalidParamError<T> extends Error {
    private _code: number;
    private _result: T;
    constructor(resp: Response<T>) {
        super(resp.message);
        this._code = resp.resultCode;
        this._result = resp.result;
    }
    public get code() {
        return this._code;
    }
    public get result() {
        return this._result;
    }
}

export class DuplicateRecordError<T> extends Error {
    private _code: number;
    private _result: T;
    constructor(resp: Response<T>) {
        super(resp.message);
        this._code = resp.resultCode;
        this._result = resp.result;
    }
    public get code() {
        return this._code;
    }
    public get result() {
        return this._result;
    }
}

export class NotFoundError<T> extends Error {
    private _code: number;
    private _result: T;
    constructor(resp: Response<T>) {
        super(resp.message);
        this._code = resp.resultCode;
        this._result = resp.result;
    }
    public get code() {
        return this._code;
    }
    public get result() {
        return this._result;
    }
}

export class ForbiddenError<T> extends Error {
    private _code: number;
    private _result: T;
    constructor(resp: Response<T>) {
        super(resp.message);
        this._code = resp.resultCode;
        this._result = resp.result;
    }
    public get code() {
        return this._code;
    }
    public get result() {
        return this._result;
    }
}

export class ServerError extends Error {
    constructor(message: string) {
        super(message);
    }
}

export class NotSupportedOperationError extends Error {
    constructor(message: string) {
        super(message);
    }
}
